import { gql } from '@apollo/client';


export const ADD_OR_UPDATE_AXLE_GROUP_IN_SIZE_AND_WEIGHT = gql`
mutation addOrUpdateAxleGroupInSizeAndWeight($input: AddOrUpdateAxleGroupInSizeAndWeightInput!) {
  addOrUpdateAxleGroupInSizeAndWeight(input: $input) {
    clientMutationId
    errors
    axleGroup {
      id
      name
      weight
      overLimit
      leftSubtotal
      rightSubtotal
      subtotal
      axles {
        id
        name
        leftAxleWeight
        rightAxleWeight
        totalAxleWeight
      }
      axleGroupType {
        id
        name
        weightLimit
      }
      axleGroupLimit
    }
    sizeAndWeight {
      id
    }
  }
}
`